import {useEffect} from 'react';
import {useInstance} from 'react-ioc';
import {useParams} from 'react-router';
import {useNavigate} from 'react-router-dom';
import {useQuery} from '@apollo/client';
import {Skeleton} from 'antd';
import {observer} from 'mobx-react-lite';

import {ENUM_BANKPAYMENT_STATUS} from '../../__generated__/global-types';
import {INDEX} from '../../config/routes';
import {Store} from '../../model/store/Store';
import {
    OnlyCashOrder,
    OnlyCashOrderVariables
} from '../../shared/graphql/__generated__/onlyCashOrder';
import {QUERY_ORDER} from '../../shared/graphql/order';

export const OrderUpdate = observer(() => {

    const {UID} = useParams()
    const navigate = useNavigate()
    const {auth} = useInstance(Store)

    const order = useQuery<OnlyCashOrder, OnlyCashOrderVariables>(QUERY_ORDER, {
        variables: {
            UID: UID!,
            token: auth.token!,
        },
        pollInterval: 5000,
        skip: auth.token === null,
    })

    useEffect(() => {
        const status = order.data?.OnlyCashOrder?.status!
        // console.log('status', status)
        if (status === ENUM_BANKPAYMENT_STATUS.PAID_3 || status === ENUM_BANKPAYMENT_STATUS.ERROR_4) {
            navigate(INDEX)
        }
    }, [navigate, order.data?.OnlyCashOrder?.status])

    return (
        <div className={'content'}>
            <Skeleton active/>
        </div>
    )
})